/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';

import { Cancel, CheckCircle } from '@material-ui/icons';
import colorContext from '../../../Context/colorContext';

interface Props {
  typeError: boolean;
  errorMessage?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  boxInfoConclueded: {
    marginTop: 50,
    width: 668,
    borderRadius: 4,
    border: '1px solid #E1E6EF',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0px 85px 34px rgba(60, 76, 112, 0.01), 0px 21px 21px rgba(60, 76, 112, 0.09)',
  },
  iconBox: {
    margin: '68px 0px 36px 0px',
  },
  textBox: {
    fontFamily: 'Roboto',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '28px',
    textAlign: 'center',
    color: '#272727',
  },
  subTextBox: {
    maxWidth: 343,
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    margin: '16px 0px 48px 0px',
    color: '#6B6D6E',
  },
  buttonRedirect: {
    color: '#ffffff',
    backgroundColor: theme.palette.primary.main,
    textTransform: 'uppercase',
    padding: '17px 22px',
    height: 48,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 700,
    textAlign: 'center',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export default function InfoMessage({
  typeError,
  errorMessage,
}: Props): JSX.Element {
  const classes = useStyles();
  const { colors } = useContext(colorContext);
  const history = useHistory();

  return (
    <Box
      className={classes.boxInfoConclueded}
      height={typeError ? 'auto' : 424}
    >
      <Box className={classes.iconBox}>
        {typeError ? (
          <Cancel style={{ color: colors.buttonErrorColor, fontSize: 46 }} />
        ) : (
          <CheckCircle style={{ color: colors.buttonSuccessColor, fontSize: 46 }} />
        )}
      </Box>
      {typeError ? (
        <>
          <Typography className={classes.textBox}>Algo deu errado!</Typography>
          <Typography className={classes.subTextBox}>
            {errorMessage ||
              'Verifique seus dados corretamente e tente novamente.'}{' '}
          </Typography>
        </>
      ) : (
        <>
          <Typography className={classes.textBox}>
            Reagendamento concluído
          </Typography>
          <Typography className={classes.subTextBox}>
            Você receberá um e-mail e uma mensagem com a confirmação do seu
            agendamento.
          </Typography>
          <Box>
            <Button
              id='confirm-agendamento'
              type='button'
              className={classes.buttonRedirect}
              onClick={() => history.push('/')}
            >
              ir para o portal
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
